import { environment } from 'src/environments/environment';

export const BASE = environment.production ? 'seguros/hogar/arriendo/cotizador' : '';

function buildPath(path: string): string {
    return BASE ? `${BASE}/${path}` : path;
}

function buildPathTenant(path: string): string {
    return environment.production ? `${path}` : path;
}

function buildPathSarlaft(path: string): string {
    return environment.production ? `${path}` : path;
}

export const DATOS_INQUILINO_INICIAL = buildPath('DatosInquilinoInicial');
export const PAGO_EXITOSO = buildPath('PagoExitoso');
export const PROCESAR_PAGO = buildPath('ProcesarPago');
export const PAGO_RECHAZADO = buildPath('PagoRechazado');
export const RESUMEN_PROCESO = buildPath('ResumenProceso');
export const VERIFICACION_NUM_CELULAR = buildPath('VerificacionNumCelular');
export const VALIDACION_CODIGO_INQUILINO = buildPath('ValidacionCodigoInquilino');
export const PREGUNTAS_SEGURIDAD = buildPath('PreguntasSeguridad');
export const FIRMA_CONTRATO = buildPath('FirmaContrato');
export const MESSAGES = buildPath('Messages');
export const FIN_FLUJO = buildPath('FinFlujo');
export const FIN_FLUJO_PEP = buildPath('FinFlujoPEP');
export const FIN_FLUJO_PEMB = buildPath('FinFlujoPEMB');
export const SCORE_FINANCIERO = buildPath('ScoreFinanciero');
export const TIEMPO_INACTIVO = buildPath('TiempoInactivo');
export const NO_SARLAFT = buildPath('NoSARLAFT');
export const NO_VALIDACION_IDENTIDAD = buildPath('NoValidacionIdentidad');
export const CONEXION_INTERRUPIDA = buildPath('ConexionInterrumpida');
export const ERROR = buildPath('Error');
export const COTIZACION_PAUSA = buildPath('CotizacionPausa');
export const INFO_COMPLEMENTARIA = buildPath('datos-complementarios-propietario');
export const COTIZACION_PAUSA_LEAD2 = buildPath('CotizacionPausaLead2');
export const COTIZACION_PAUSA_LEAD3 = buildPath('CotizacionPausaLead3');
export const CUMULO = buildPath('Cumulo');
export const LOADER = buildPath('Loader');
export const CARD_INMUEBLE = buildPath('CardInmueble');
export const MENSAJE_PROPIETARIO = buildPath('MensajePropietario');
export const PUERTA_ENTRADA = buildPath('PuertaEntrada');
export const INICIO = buildPath('Inicio');
export const FIN_FLUJO_NO = buildPath('FinFlujoNo');
export const HOME = buildPath('Home');

export const INFO_ARRENDAMIENTOS = buildPath('InfoArrendamientos');
export const INFO_ARRENDAMIENTOS_NO_IQ = buildPath('InfoArrendamientosNoIQ');
export const LOADING = buildPath('Loading');
export const LOADING_NO = buildPath('LoadingNo');
export const PLANES_SEGUROS = buildPath('PlanesSeguros');
export const PLANES_NO = buildPath('PlanesNo');
export const ARMA_TU_PLAN = buildPath('ArmaTuPlan');
export const ARMA_TU_PLAN_NO = buildPath('ArmaTuPlanNo');
export const RESUMEN_COMPRA = buildPath('ResumenCompra');
export const DURACION_CONTRATO = buildPath('DuracionContrato');
export const DATOS_PROPIETARIO = buildPath('DatosPropietario');
export const INMUEBLE = buildPath('Inmueble');
export const DATOS_INQUILINO = buildPath('DatosInquilino');
export const INFO_INMUEBLE = buildPath('InfoInmueble');
export const FEEDBACK = buildPath('Feedback');
export const DEFAULT = `${BASE}`;
export const REDIRECT = 'seguros/hogar/arriendo/cotizador';

// tenant
export const DATOSINQUILINO = buildPathTenant('datos-inquilino');
export const OTP_VALIDATION = buildPathTenant('otp-validation');
export const OTP_VALIDATION_SECOND_STEP = buildPathTenant('tptsecondstep');
export const SECURITY_QUESTION = buildPathTenant('segurity-question');
export const SIGNCONTRACT = buildPathTenant('Firma-contrato');
export const END_PROCESS = buildPathTenant('end-process');
export const END_PAUSE = buildPathTenant('endpause');
export const RESUMENPROCESO = buildPathTenant('resumen-proceso');
export const INACTIVIDAD = buildPathTenant('inatividad');
export const FEEDBACKTENANT = buildPathTenant('feedback');
export const EROR404 = buildPathTenant('error404');
export const PAUSE = buildPathTenant('endpause');
export const DEFAULTENANT = '/seguros/hogar/arriendo/inquilino'

// sarlaft
export const RESUMEN_SARLAFT = buildPathSarlaft('resumen-sangrilaft');
export const SARLAFT_END = buildPathSarlaft('sangrilafend');
export const SARLAFT_OTP_LISTNUMBERS = buildPathSarlaft('sarlaft-otp-listnumbers');
export const SARLAFT_OTP = buildPathSarlaft('sarlaft-otp');
export const SECURITY = buildPathSarlaft('security');
export const FIRMA = buildPathSarlaft('firma');
export const SARLAFT_PAUSE = buildPathSarlaft('pause');
export const SARLAFT_ERROR_404 = buildPathSarlaft('error-404');
export const SARLAFT_INACTIVIDAD = buildPathSarlaft('inactividad');
export const SARLAFT_ROOT = buildPathSarlaft('sarlaft');
export const SARLAFT_FEEDBACK = buildPathSarlaft('feedback');
export const DEFAULTSARLAFT = '/seguros/hogar/arriendo/sarlaft'
export const OTRO_PRODUCTO = 'otro-producto'
export const POLIZA_ACTIVA = 'poliza-activa'

// Pasarela de pago Place to Pay (Lightbox)
export const RESUMEN_COMPRA_P2P = buildPath('resumen-compra-p2p');
export const PROCESANDO_PAGO = buildPath('procesando-pago');
export const PAGO_APROBADO = buildPath('pago-aprobado');
export const PAGO_APROBADO_NO_AP = buildPath('pago-aprobado-no-ap');
export const PAGO_RECHAZADO_P2P = buildPath('pago-rechazado-p2p');
export const TENEMOS_TUS_DATOS = buildPath('tenemos-tus-datos');
export const SARLAFT_DENIED = buildPath('sarlaft-denied');

// Ruta utilizada para redirección cuando se detecta DevTools
// Podemos usar una ruta existente para este propósito.
export const NO_ARRIENDO = buildPath('no_devtolls');


//
/**
 * Url para el modulo de las páginas finales
 */
export const FINAL_PAGE = buildPath('final_page');